import { useTranslation } from 'next-i18next'
import { useTheme } from 'styled-components'

import { TRANSLATION_KEYS } from '@/constants/localization'
import { R2SSellerDisclaimerContainer } from '@/features/listing/components/reply-to-seller/conversations/styled'
import { BodyText } from '@/ui/atoms/body-text'

export const R2SSellerDisclaimer = () => {
  const { t } = useTranslation(TRANSLATION_KEYS.R2S)
  const { colors } = useTheme()

  return (
    <R2SSellerDisclaimerContainer>
      <BodyText size="medium" color={colors.grey.light2}>
        {t('r2s:message_form.seller.disabled_disclaimer')}
      </BodyText>
    </R2SSellerDisclaimerContainer>
  )
}
